import type { BillingApi } from '@eis/billingservice-sdk';
import type { BillRunKind } from '@eis/core';

/** The run kinds a reader may start (SDD-015 §5.6) — the service's closed set. */
export const RUN_KINDS: readonly BillRunKind[] = ['INVOICE', 'ESTIMATE', 'RECONCILE'];

export interface BillRunRow {
  readonly id: string;
  readonly code: string;
  readonly kind: string;
  readonly runDate: string;
  readonly selected: number;
  readonly created: number;
  readonly skipped: number;
  readonly failed: number;
  readonly outcome: string;
  readonly startedAt: string;
  readonly finishedAt: string;
  readonly triggeredBy: string;
  readonly report: Readonly<Record<string, unknown>>;
}

export function toBillRunRows(items: readonly BillingApi.BillRun[] | undefined): BillRunRow[] {
  return (items ?? []).map((run) => ({
    id: run.code ?? '',
    code: run.code ?? '',
    kind: run.kind ?? '',
    runDate: (run.runDate ?? '').slice(0, 10),
    selected: run.selected ?? 0,
    created: run.created ?? 0,
    skipped: run.skipped ?? 0,
    failed: run.failed ?? 0,
    outcome: run.outcome ?? '',
    startedAt: run.startedAt ?? '',
    finishedAt: run.finishedAt ?? '',
    triggeredBy: run.triggeredBy ?? '',
    report: run.report ?? {},
  }));
}

/** A run that FAILED touched nothing and says so; PARTIAL did some of its work; the rest is fine. */
export const runNeedsAttention = (outcome: string): boolean => outcome === 'FAILED' || outcome === 'PARTIAL';
